/**
 * Created by Jerker Nord on 2024-03-12.
 */
import {LonerMaxWinView} from "../base/LonerMaxWinView";
import {Loner} from "../../Loner";
import {gsap} from "gsap";
import {LonerSound} from "../../sound/LonerSound";
import {LonerSymbolStates} from "../../../core/reel/ReelInterfaces";

export class LonerMainGameMaxWinView extends LonerMaxWinView {

    constructor() {
        super();
        this.name = "LonerMainGameMaxWinView";
    }

    public getMaxWinTL(buttonCallback:Function):gsap.core.Timeline {
        if(Loner.model.isNaturalMaxWin == true) {
            return gsap.timeline().add(super.getMaxWinTL(buttonCallback), "+=0.5");
        } else {
            for (let i:number=0;i<Loner.model.scatterTransform.length;i++){
                if (Loner.model.scatterTransform[i] == LonerSymbolStates.SCATTER_MAX_WIN){
                    Loner.scatterPool.getScatterSymbolOnReel(i).startScatterMaxWinAnimation();
                }
            }
            return super.getMaxWinTL(buttonCallback);
        }
    }

    protected playMaxWinLoop():void {
        Loner.soundPlayer.stopSound(LonerSound.MAIN_GAME_MUSIC);
        super.playMaxWinLoop();
    }
}